import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Select } from '@chakra-ui/react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Get locale from URL query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const localeParam = urlParams.get('locale');

    // If locale parameter exists and is a valid language code, use it
    if (localeParam && ['en', 'de', 'fr', 'es', 'nl'].includes(localeParam)) {
      i18n.changeLanguage(localeParam);
    }
  }, [i18n]);

  const handleLanguageChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <Box position="fixed" top="20px" right="20px" zIndex="1000">
      <Select
        value={i18n.language}
        onChange={handleLanguageChange}
        size="sm"
        width="100px"
        bg="white"
        borderRadius="md"
      >
        <option value="en">English</option>
        <option value="de">Deutsch</option>
        <option value="fr">Français</option>
        <option value="es">Español</option>
        <option value="nl">Nederlands</option>
      </Select>
    </Box>
  );
};

export default LanguageSwitcher; 